import { Controller } from "stimulus"

export default class extends Controller {
  static values = { delay: Number }

  select() {
    setTimeout(() => {
      this.element.requestSubmit()
    }, this.delayValue || 350)
  }

  submitWhenComplete(event) {
    const input = event.target
    const target = parseInt(input.getAttribute("maxlength"), 10)
    if (!target || input.value.length < target) return
    if (input.checkValidity && !input.checkValidity()) return

    setTimeout(() => {
      this.element.requestSubmit()
    }, this.delayValue || 350)
  }
}
